import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import menu from "../../images/menu.svg";
import logo from "../../images/logo.svg";
import styles from "../../css/CommonComponent/HeaderWithProducts.module.css";
import dropdownicon from "../../images/dropwdownicon.svg";

const HeaderWithProducts = () => {
  const ref = useRef();
  const dropdownref = useRef();

  const [menuOpen, setMenuOpen] = useState(false);
  const [dropDown, setDropDown] = useState(false);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (menuOpen && ref.current && !ref.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };

    const checkForDropdown = (e) => {
      if (
        dropDown &&
        dropdownref.current &&
        !dropdownref.current.contains(e.target)
      ) {
        setDropDown(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    document.addEventListener("mousedown", checkForDropdown);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
      document.removeEventListener("mousedown", checkForDropdown);
    };
    //eslint-disable-next-line
  }, [menuOpen, dropdownref]);

  return (
    <section className={styles.headerContainer}>
      <Link to="https://eqlfin.com">
        <img loading="lazy" src={logo} alt="logo" style={{ width: "70%" }} />
      </Link>
      <span className={styles.linkSection}>
        <div
          className={styles.aboutText}
          onClick={() => setDropDown(!dropDown)}
          ref={dropdownref}
          onMouseOver={() => setDropDown(true)}
          onMouseOut={() => setDropDown(false)}
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            Premium Services <img src={dropdownicon} alt="dropdownicon" />
          </span>
          {dropDown && (
            <div className={styles.dropdown}>
              <Link
                to="https://eqlfin.com/services/priority-payments"
                className={styles.link}
              >
                Priority Payments
              </Link>

              <Link
                to="https://eqlfin.com/services/reward-benefits"
                className={styles.link}
              >
                Reward Benefits
              </Link>

              <Link
                to="https://eqlfin.com/services/personal-assistant"
                className={styles.link}
              >
                Personal Assistant
              </Link>
            </div>
          )}
        </div>
        <Link
          to="https://eqlfin.com/services/balance-confirmation"
          className={styles.aboutText}
        >
          Balance Confirmation
        </Link>
        <a href="https://developer.eqlfin.com/" className={styles.aboutText}>
          Developer
        </a>
        <Link to="https://eqlfin.com/about" className={styles.aboutText}>
          <span>About Us</span>
        </Link>
      </span>
      <img
        loading="lazy"
        src={menu}
        className={styles.menuIcon}
        alt="menu icon"
        onClick={() => setMenuOpen(!menuOpen)}
      />
      {menuOpen && (
        <div className={styles.moreMenu} ref={ref}>
          <div
            className={styles.dropdownAboutText}
            onClick={() => setDropDown(!dropDown)}
          >
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                zIndex: 200,
              }}
            >
              Premium Services <img src={dropdownicon} alt="dropdownicon" />
            </span>
            {dropDown && (
              <>
                <div className={styles.dropdown}>
                  <Link
                    to="https://eqlfin.com/services/priority-payments"
                    className={styles.link}
                  >
                    Priority Payments
                  </Link>

                  <Link
                    to="https://eqlfin.com/services/reward-benefits"
                    className={styles.link}
                  >
                    Reward Benefits
                  </Link>
                  <Link
                    to="https://eqlfin.com/services/personal-assistant"
                    className={styles.link}
                  >
                    Personal Assistant
                  </Link>
                </div>
              </>
            )}
          </div>
          <Link
            to="https://eqlfin.com/services/balance-confirmation"
            className={styles.aboutText}
          >
            Balance Confirmation
          </Link>
          <a href="https://developer.eqlfin.com/" className={styles.aboutText}>
            Developer
          </a>
          <Link to="https://eqlfin.com/about" className={styles.aboutText}>
            <span>ABOUT US</span>
          </Link>
        </div>
      )}
    </section>
  );
};

export default HeaderWithProducts;
